import PlotlyChart from './PlotlyChart';
import { COLORS, mergeLayout, mergeConfig } from '../utils/chartTheme';

export default function BarChart({ data, chartOptions = {} }) {
  const traces = data.map((trace, i) => ({
    x: trace.x,
    y: trace.y,
    type: 'bar',
    name: trace.name,
    marker: {
      color: COLORS[i % COLORS.length],
      line: { width: 0 },
    },
    hovertemplate: '%{x}: %{y}<extra>%{fullData.name}</extra>',
  }))

  const layout = mergeLayout({
    ...(chartOptions.title ? { title: { text: chartOptions.title, font: { size: 15, color: '#334155' }, x: 0, xanchor: 'left', pad: { l: 4 } } } : {}),
    bargap: 0.3,
    bargroupgap: 0.1,
    ...(chartOptions.layout || {}),
  })

  return (
    <PlotlyChart
      data={traces}
      layout={layout}
      config={mergeConfig()}
      style={{ width: '100%', height: '400px' }}
    />
  );
}
